import React from "react";
import { breadcrumbs } from "../../common/breadcrumbs";
import { TopBanner } from "../../common/TopBanner";
import { Link } from "../../lib/Link";
import { openContactSelector } from "../../common/callUtil"
import { getUrl } from "../../lib/masterUtil";


export const feature = type => {
  document.title = "トランクルームをお探しなら『ハローストレージ』【公式】｜ハローストレージのおもてなし";
  return (
    <div className="container">
      {breadcrumbs(type, [{ text: "ハローストレージのおもてなし７品質" }])}
      
      <main className="feature_content">
        <section>
          <h1 className="page_title">
            <img src="resource/img/static/feature/page_title-sp.png" alt="ハローストレージの「おもてなし７品質」" className="hidden-pc" />
            <img src="resource/img/static/feature/page_title-pc.png" alt="ハローストレージの「おもてなし７品質」" className="hidden-sp" />
          </h1>
          <div className="anchor_bg">
            <ol className="list list_anchor">
              <li className="list_item">
                <Link to="#appeal_1" className="anchor">
                  <img src="resource/img/static/feature/appeal_1-sp.png" alt="「すぐに使いたい」に応える　スピード契約" className="hidden-pc" />
                  <img src="resource/img/static/feature/appeal_1-pc.png" alt="「すぐに使いたい」に応える　スピード契約" className="hidden-sp" />
                </Link>
              </li>
              <li className="list_item">
                <Link to="#appeal_2" className="anchor">
                  <img src="resource/img/static/feature/appeal_2-sp.png" alt="困った時も安心、いつでも駆けつける　スピードサポート" className="hidden-pc" />
                  <img src="resource/img/static/feature/appeal_2-pc.png" alt="困った時も安心、いつでも駆けつける　スピードサポート" className="hidden-sp" />
                </Link>
              </li>
              <li className="list_item">
                <Link to="#appeal_3" className="anchor">
                  <img src="resource/img/static/feature/appeal_3-sp.png" alt="気軽に相談、やさしい対応の　コールセンター" className="hidden-pc" />
                  <img src="resource/img/static/feature/appeal_3-pc.png" alt="気軽に相談、やさしい対応の　コールセンター" className="hidden-sp" />
                </Link>
              </li>
              <li className="list_item">
                <Link to="#appeal_4" className="anchor">
                  <img src="resource/img/static/feature/appeal_4-sp.png" alt="いつも快適、徹底的な　巡回清掃" className="hidden-pc" />
                  <img src="resource/img/static/feature/appeal_4-pc.png" alt="いつも快適、徹底的な　巡回清掃" className="hidden-sp" />
                </Link>
              </li>
              <li className="list_item">
                <Link to="#appeal_5" className="anchor">
                  <img src="resource/img/static/feature/appeal_5-sp.png" alt="「あったらいいな…」をカタチにします。　アドバイスカード" className="hidden-pc" />
                  <img src="resource/img/static/feature/appeal_5-pc.png" alt="「あったらいいな…」をカタチにします。　アドバイスカード" className="hidden-sp" />
                </Link>
              </li>
              <li className="list_item">
                <Link to="#appeal_6" className="anchor">
                  <img src="resource/img/static/feature/appeal_6-sp.png" alt="最高の便利さを提供します。　わくわくアイデア" className="hidden-pc" />
                  <img src="resource/img/static/feature/appeal_6-pc.png" alt="最高の便利さを提供します。　わくわくアイデア" className="hidden-sp" />
                </Link>
              </li>
              <li className="list_item">
                <Link to="#appeal_7" className="anchor">
                  <img src="resource/img/static/feature/appeal_7-sp.png" alt="きっと見つかるお気に入り。　お客様ニーズを徹底解析" className="hidden-pc" />
                  <img src="resource/img/static/feature/appeal_7-pc.png" alt="きっと見つかるお気に入り。　お客様ニーズを徹底解析" className="hidden-sp" />
                </Link>
              </li>
            </ol>
          </div>

          <div className="content">
            <section className="appeal_point appeal_point_1" id="appeal_1">
              <div className="content_box">
                <h2 className="appeal_title">
                  <img src="resource/img/static/feature/appeal_title1-sp.png" alt="" className="hidden-pc" />
                  <img src="resource/img/static/feature/appeal_title1-pc.png" alt="" className="hidden-sp" />
                </h2>
                <div className="text_wrap">
                  <p className="paragraph">
                    今日思いたって、<br className="hidden-pc"/>今日使えるのはハローストレージだけ！<br/>
                    <Link to={getUrl({ condition: { keyword: "スマートキー" } })} className="text_anchor">
                      スマートキー物件をみる
                    </Link>
                  </p>
                  <p className="paragraph">
                    24時間365日、いつでも申込できる！<br/>
                    <Link to="/list/" className="text_anchor">
                      WEBで申込する
                    </Link>
                  </p>
                </div>
              </div>
              <figure className="figure">
                <img src="resource/img/static/feature/appeal_thumb1.jpg" alt=""/>
              </figure>
            </section>
            <section className="appeal_point appeal_point_2" id="appeal_2">
              <div className="content_box">
                <h2 className="appeal_title">
                  <img src="resource/img/static/feature/appeal_title2-sp.png" alt="" className="hidden-pc" />
                  <img src="resource/img/static/feature/appeal_title2-pc.png" alt="" className="hidden-sp" />
                </h2>
                <div className="text_wrap">
                  <p className="paragraph">
                    あなたの困ったにすぐかけつけるのは<br className="hidden-pc"/>ハローストレージ<br/>
                    だからいつでも安心！
                  </p>
                </div>
              </div>
              <figure className="figure">
                <img src="resource/img/static/feature/appeal_thumb2.jpg" alt=""/>
              </figure>
            </section>
            <section className="appeal_point appeal_point_3" id="appeal_3">
              <div className="content_box">
                <h2 className="appeal_title">
                  <img src="resource/img/static/feature/appeal_title3-sp.png" alt="" className="hidden-pc" />
                  <img src="resource/img/static/feature/appeal_title3-pc.png" alt="" className="hidden-sp" />
                </h2>
                <div className="text_wrap">
                  <p className="paragraph">
                    なんでも相談してください！<br/>
                    <Link
                      className="text_anchor"
                      onClick={() => openContactSelector({ eventTrackingId: 'tel_action_apeal_points' })}
                    >
                      相談してみる
                    </Link>
                  </p>
                </div>
              </div>
              <figure className="figure">
                <img src="resource/img/static/feature/appeal_thumb3.jpg" alt=""/>
              </figure>
            </section>
            <section className="appeal_point appeal_point_4" id="appeal_4">
              <div className="content_box">
                <h2 className="appeal_title">
                  <img src="resource/img/static/feature/appeal_title4-sp.png" alt="" className="hidden-pc" />
                  <img src="resource/img/static/feature/appeal_title4-pc.png" alt="" className="hidden-sp" />
                </h2>
                <div className="text_wrap">
                  <p className="paragraph">
                    月３回の巡回だから<br/>
                    <strong>安心・清潔・誠実</strong>
                  </p>
                </div>
              </div>
              <figure className="figure">
                <img src="resource/img/static/feature/appeal_thumb4.jpg" alt=""/>
              </figure>
            </section>
            <section className="appeal_point appeal_point_5" id="appeal_5">
              <div className="content_box">
                <h2 className="appeal_title">
                  <img src="resource/img/static/feature/appeal_title5-sp.png" alt="" className="hidden-pc" />
                  <img src="resource/img/static/feature/appeal_title5-pc.png" alt="" className="hidden-sp" />
                </h2>
                <div className="text_wrap">
                  <p className="paragraph">
                    お客さまの声からこんな改善うまれてます！
                  </p>
                  <ul className="list">
                    <li className="list_item">
                      <span>● 運搬時、車の貸出しがあったらな</span>
                      <img src="resource/img/static/feature/feature5_icon.png" alt="" className="feature5_icon" />
                      <Link to="/service/#service_01" className="text_anchor">
                        運転手付き「レントラ便」サービス開始！
                      </Link>
                    </li>
                    <li className="list_item">
                      <span>● エントランス入口にストッパーがあればいいな</span>
                      <img src="resource/img/static/feature/feature5_icon.png" alt="" className="feature5_icon" />
                      ⇒ ストッパー設置完了
                    </li>
                  </ul>
                  <a href="https://info.arealink.co.jp/advicecard" className="btn">
                    投稿してみる
                  </a>
                </div>
              </div>
              <figure className="figure">
                <img src="resource/img/static/feature/appeal_thumb5.jpg" alt=""/>
              </figure>
            </section>
            <section className="appeal_point appeal_point_6" id="appeal_6">
              <div className="content_box">
                <h2 className="appeal_title">
                  <img src="resource/img/static/feature/appeal_title6-sp.png" alt="" className="hidden-pc" />
                  <img src="resource/img/static/feature/appeal_title6-pc.png" alt="" className="hidden-sp" />
                </h2>
                <div className="text_wrap">
                  <p className="paragraph">
                    キティがカギを開けてくれる物件が登場！？<br/>
                    <Link to="/app/" className="text_anchor">
                      キティが開けるスマートキーって？
                    </Link>
                  </p>
                  <p className="paragraph">
                    かわいいミニチュア家具が<br/>
                    トコトコお部屋サイズを教えてくれる？！ <br/>
                    <Link to="/beginner/movie/" className="text_anchor">
                      ミニチュアでお部屋サイズを知ろう！
                    </Link>
                  </p>
                </div>
              </div>
              <figure className="figure">
                <img src="resource/img/static/feature/appeal_thumb6.jpg" alt=""/>
              </figure>
            </section>
            <section className="appeal_point appeal_point_7" id="appeal_7">
              <div className="content_box">
                <h2 className="appeal_title">
                  <img src="resource/img/static/feature/appeal_title7-sp.png" alt="" className="hidden-pc" />
                  <img src="resource/img/static/feature/appeal_title7-pc.png" alt="" className="hidden-sp" />
                </h2>
                <div className="text_wrap">
                  <p className="paragraph">
                    お客さまのニーズにお応えします！<br/>
                    「あの場所に出してほしい」の声を<br className="hidden-pc"/>お聞かせください！<br/>
                    <a href="/hello-storage/request/" className="text_anchor" target="_blank">
                      出店希望エリアを伝えてみる
                    </a>
                  </p>
                </div>
              </div>
              <figure className="figure">
                <img src="resource/img/static/feature/appeal_thumb7.jpg" alt=""/>
              </figure>
            </section>
          </div>

          <div className="information cf">
            <div className="hidden-sp">
              <Link to="/lineup/" className="textArea">
                <img src="resource/img/static/beginner/lineup.png" />
                <span>
                  商品ラインナップは
                  <br />
                  こちら
                </span>
              </Link>
              <Link to="/flow/" className="textArea">
                <img src="resource/img/static/beginner/flow.png" />
                <span>
                  お申し込みから
                  <br />
                  ご契約の流れまで
                </span>
              </Link>
              <Link to="/voice2/" className="textArea">
                <img src="resource/img/static/beginner/voice.png" />
                <span>
                  実際の
                  <br />
                  お客様の声
                </span>
              </Link>
            </div>
            <div className="hidden-pc">
              <Link to="/lineup/" className="text1">
                <img src="resource/img/static/beginner/lineup_sp.png" />
                <span>
                  商品ラインナップは
                  <br />
                  こちら
                </span>
              </Link>
              <Link to="/flow/" className="text2">
                <img src="resource/img/static/beginner/flow_sp.png" />
                <span>
                  お申し込みから
                  <br />
                  ご契約の流れまで
                </span>
              </Link>
              <Link to="/voice2/" className="text3">
                <img src="resource/img/static/beginner/voice_sp.png" />
                <span>
                  実際の
                  <br />
                  お客様の声
                </span>
              </Link>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};



// WEBPACK FOOTER //
// ./pages/new/feature.jsx